import type { RunningMetrics } from './runningWorkoutMetrics';
import type { RangeStats } from './workoutStream';

/** Only range data may populate this panel; legacy cycling load/calories are ignored. */
export function runningSelectionMetrics(
  calculation: { running_metrics?: RunningMetrics | null; total_ascent?: number; total_descent?: number },
  local: RangeStats,
  cadenceIsSpm: boolean,
): RunningMetrics {
  const metrics = calculation.running_metrics;
  if (metrics) return {
    ...metrics,
    heart_rate: metrics.heart_rate ?? local.heartRate ?? undefined,
    power: metrics.power ?? local.power ?? undefined,
    cadence: metrics.cadence ?? (cadenceIsSpm ? local.cadence : null),
    avg_pace_seconds_per_km: metrics.avg_pace_seconds_per_km ?? (local.speed && local.speed.avg > 0 ? 3600 / local.speed.avg : null),
    ascent_m: metrics.ascent_m ?? calculation.total_ascent,
    descent_m: metrics.descent_m ?? calculation.total_descent,
  };
  return {
    version: 'local-selection', cadence_unit: 'spm', raw_cadence_unit: 'cycles/min',
    duration_seconds: local.duration,
    avg_pace_seconds_per_km: local.speed && local.speed.avg > 0 ? 3600 / local.speed.avg : null,
    cadence: cadenceIsSpm ? local.cadence : null,
    heart_rate: local.heartRate ?? undefined,
    power: local.power ?? undefined,
  };
}
